import React, { Component } from "react";
import ComparisonBox from "../ComparisonBox";
import ComparisonChart from "./ComparisonChart";
import { Element } from "react-scroll";

var childcare_img = require("../icons/Childcare.png");
var groceries_img = require("../icons/Groceries.png");
var housing_img = require("../icons/Housing.png");
var transportation_img = require("../icons/Transportation.png");
var utilites_img = require("../icons/Utilities.png");

export default class CityComparison extends Component {
  switchHousing(option){
    switch(option){
      case "own":
        return ["Buy", "Property Taxes"];
      case "rent":
        return ["Rent"];
      default:
        return ["Buy", "Rent", "Property Taxes"];
    }
  }

  switchHousingDataKingston(option){
    switch(option){
      case "own":
        return [(this.props.kingstonData.own / 25) * 1.035, this.props.kingstonData.property_taxes];
      case "rent":
        return [this.props.kingstonData.rent];
      default:
        return [(this.props.kingstonData.own / 25) * 1.035, this.props.kingstonData.rent, this.props.kingstonData.property_taxes]
    }
  }

  switchHousingDataSelected(option){
    switch(option){
      case "own":
        return [(this.props.selectedCityData.own / 25) * 1.035, this.props.selectedCityData.property_taxes];
      case "rent":
        return [this.props.selectedCityData.rent];
      default:
        return [(this.props.selectedCityData.own / 25) * 1.035, this.props.selectedCityData.rent, this.props.selectedCityData.property_taxes]
    }
  }

  render() {
    return (
      <div>
        <Element name="page1" />
        {this.props.showAnyArrows && this.props.getScrollLink("display", "up")}
        <ComparisonBox
          mobile={!this.props.showAnyArrows}
          title="Housing"
          boxHeight='42vh'
          cityData={this.switchHousingDataSelected(this.props.homeOption)[0]}
          kingstonData={this.switchHousingDataKingston(this.props.homeOption)[0]}
          image={housing_img}
          float="left"
          chart={
            <ComparisonChart
              title={"Housing"}
              cityName={this.props.selectedCityData.name}
              data={this.switchHousing(this.props.homeOption)}
              kingstonData={this.switchHousingDataKingston(this.props.homeOption)}
              cityData={this.switchHousingDataSelected(this.props.homeOption)}
            />
          }
        />

        <ComparisonBox
          mobile={!this.props.showAnyArrows}
          title="Utilities"
          boxHeight='42vh'
          cityData={
            this.props.selectedCityData.energy +
            this.props.selectedCityData.water +
            this.props.selectedCityData.heat
          }
          kingstonData={
            this.props.kingstonData.energy +
            this.props.kingstonData.water +
            this.props.kingstonData.heat
          }
          image={utilites_img}
          float="right"
          chart={
            <ComparisonChart
              title={"Utilities"}
              cityName={this.props.selectedCityData.name}
              data={["Water", "Heat", "Energy"]}
              kingstonData={[
                this.props.kingstonData.water,
                this.props.kingstonData.heat,
                this.props.kingstonData.energy
              ]}
              cityData={[
                this.props.selectedCityData.water,
                this.props.selectedCityData.heat,
                this.props.selectedCityData.energy
              ]}
            />
          }
        />

        {this.props.showAnyArrows &&
          this.props.getScrollLink("page2", "down")}
        <Element name="page2" />
        {this.props.showAnyArrows &&
          this.props.getScrollLink("page1", "up")}

        <ComparisonBox
          mobile={!this.props.showAnyArrows}
          title="Groceries"
          boxHeight={this.props.showTimeSavedArrow ? '28vh' : '26vh'}
          cityData={this.props.selectedCityData.groceries}
          kingstonData={this.props.kingstonData.groceries}
          image={groceries_img}
          float="left"
          chart={
            <ComparisonChart
              title={"Groceries"}
              cityName={this.props.selectedCityData.name}
              data={["Groceries"]}
              kingstonData={[this.props.kingstonData.groceries]}
              cityData={[this.props.selectedCityData.groceries]}
            />
          }
        />

        <ComparisonBox
          mobile={!this.props.showAnyArrows}
          title="Transportation"
          boxHeight={this.props.showTimeSavedArrow ? '28vh' : '26vh'}
          cityData={this.props.selectedCityData.public_transit}
          kingstonData={this.props.kingstonData.public_transit}
          image={transportation_img}
          float="right"
          chart={
            <ComparisonChart
              title={"Transportation"}
              cityName={this.props.selectedCityData.name}
              data={["Public Transit", "Vehicle Insurance Premiums", "Gas"]}
              kingstonData={[
                this.props.kingstonData.public_transit,
                this.props.kingstonData.insurance,
                this.props.kingstonData.gasoline
              ]}
              cityData={[
                this.props.selectedCityData.public_transit,
                this.props.selectedCityData.insurance,
                this.props.selectedCityData.gasoline
              ]}
            />
          }
        />

        <ComparisonBox
          mobile={!this.props.showAnyArrows}
          title="Child Care"
          boxHeight={this.props.showTimeSavedArrow ? '28vh' : '26vh'}
          cityData={this.props.selectedCityData.child_care}
          kingstonData={this.props.kingstonData.child_care}
          image={childcare_img}
          float="left"
          chart={
            <ComparisonChart
              title={"Child Care"}
              cityName={this.props.selectedCityData.name}
              data={["Child Care"]}
              kingstonData={[this.props.kingstonData.child_care]}
              cityData={[this.props.selectedCityData.child_care]}
            />
          }
        />
        {this.props.showAnyArrows &&
          this.props.showTimeSavedArrow &&
          this.props.getScrollLink("page3", "down", "10vh")}
        <Element name="page3" />
        {this.props.showAnyArrows &&
          this.props.showTimeSavedArrow &&
          this.props.getScrollLink("page2", "up")}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Calculator/sections/CityComparison.js